import React from 'react';
import { DOC_TYPE_FORM } from '../helpers/utils';
import {
  setDocumentForm,
  shareActiveDocumentState
} from '../../redux/actions/rootAction';
import withDocumentCommon from '../helpers/withDocumentCommon';
import { xconnect } from '../../redux/xconnect';

export default function withQuickFormDocument(WrappedComponent) {
  // noinspection JSPotentiallyInvalidUsageOfThis
  class withQuickFormDocumentWrapper extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state, ownProps) => {
    const requestedDocument = ownProps.document || {
      id: 'fake_document',
      attributes: {
        formStructure: [[]]
      }
    };

    return {
      validateSmartFill: true,
      isLandscape: state.isLandscape,
      actualScreenSize: state.actualScreenSize,
      startFromLastPage: ownProps.startFromLastPage,
      smartFillFormMode: ownProps.smartFillFormMode,
      formData: state.forms.get(requestedDocument.id) || new Map(),
      isVirtualKeyboardOpen: state.isVirtualKeyboardOpen,
      document: requestedDocument
    };
  };

  const mapDispatchToProps = dispatch => ({
    shareActiveDocumentState: state =>
      dispatch(shareActiveDocumentState(DOC_TYPE_FORM, state)),
    setDocumentForm: (documentId, form) =>
      dispatch(setDocumentForm(documentId, form))
  });

  return withDocumentCommon(
    xconnect(mapStateToProps, mapDispatchToProps)(withQuickFormDocumentWrapper)
  );
}
